"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _icons = require("@ori-ui/icons");
var _material = require("@ori-ui/mui-bundle/material");
var _system = require("@ori-ui/mui-bundle/system");
var _constants = require("../constants");
var _shape = _interopRequireDefault(require("../shape"));
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable complexity -- there are a lot of options */ var styleOverrides = {
    root: function(param) {
        var theme = param.theme, ownerState = param.ownerState;
        var _ownerState_color, _ownerState_color1, _ownerState_color2, _ownerState_color3, _ownerState_color4, _ownerState_color5, _ownerState_color6, _ownerState_color7, _ownerState_color8, _ownerState_color9, _ownerState_color10, _ownerState_color11, _ownerState_color12, _ownerState_color13;
        var _obj, _obj1, _obj2, _obj3, _obj4;
        return _object_spread({
            fontWeight: 'bold',
            fontSize: '1.2rem',
            borderRadius: _shape.default.borderRadius,
            paddingTop: 5,
            paddingBottom: 5,
            lineHeight: '1',
            textTransform: 'uppercase',
            height: 28
        }, ownerState.variant === 'tag' && (_obj = {
            color: _constants.colors.lightItem[(_ownerState_color = ownerState.color) !== null && _ownerState_color !== void 0 ? _ownerState_color : 'default'].textTag,
            background: _constants.colors.lightItem[(_ownerState_color1 = ownerState.color) !== null && _ownerState_color1 !== void 0 ? _ownerState_color1 : 'default'].background
        }, _define_property(_obj, "&.".concat(_material.chipClasses.clickable, ":hover,&.").concat(_material.chipClasses.clickable, ":focus"), {
            background: (0, _system.alpha)(theme.palette[(_ownerState_color2 = ownerState.color) !== null && _ownerState_color2 !== void 0 ? _ownerState_color2 : 'default'].dark, 0.2)
        }), _define_property(_obj, "& .".concat(_material.chipClasses.deleteIcon), {
            color: _constants.colors.lightItem[(_ownerState_color3 = ownerState.color) !== null && _ownerState_color3 !== void 0 ? _ownerState_color3 : 'default'].textTag,
            fontSize: '1.6rem'
        }), _define_property(_obj, "& .".concat(_material.chipClasses.deleteIcon, ":hover"), {
            color: theme.palette[(_ownerState_color4 = ownerState.color) !== null && _ownerState_color4 !== void 0 ? _ownerState_color4 : 'default'].dark
        }), _define_property(_obj, "&.".concat(_material.chipClasses.sizeMedium), {
            height: 28,
            fontSize: '1.2rem'
        }), _define_property(_obj, "&.".concat(_material.chipClasses.sizeSmall), {
            height: 25,
            fontSize: '1rem'
        }), _obj), ownerState.variant === 'filled' && (_obj1 = {
            color: theme.palette[(_ownerState_color5 = ownerState.color) !== null && _ownerState_color5 !== void 0 ? _ownerState_color5 : 'default'].contrastText,
            background: theme.palette[(_ownerState_color6 = ownerState.color) !== null && _ownerState_color6 !== void 0 ? _ownerState_color6 : 'default'].main
        }, _define_property(_obj1, "& .".concat(_material.chipClasses.deleteIcon), {
            color: theme.palette[(_ownerState_color7 = ownerState.color) !== null && _ownerState_color7 !== void 0 ? _ownerState_color7 : 'default'].contrastText
        }), _define_property(_obj1, "& .".concat(_material.chipClasses.deleteIcon, ":hover"), {
            color: theme.palette[(_ownerState_color8 = ownerState.color) !== null && _ownerState_color8 !== void 0 ? _ownerState_color8 : 'default'].light
        }), _obj1), ownerState.variant === 'filled' && ownerState.color === 'success' && (_obj2 = {
            color: _constants.colors.text.primary,
            background: theme.palette.success.light
        }, _define_property(_obj2, "& .".concat(_material.chipClasses.deleteIcon), {
            color: _constants.colors.text.primary
        }), _define_property(_obj2, "& .".concat(_material.chipClasses.deleteIcon, ":hover"), {
            color: theme.palette.success.contrastText
        }), _obj2), ownerState.variant === 'rounded' && _object_spread((_obj3 = {
            borderRadius: 999,
            height: 32,
            paddingLeft: 5,
            paddingRight: 5,
            color: theme.palette[(_ownerState_color9 = ownerState.color) !== null && _ownerState_color9 !== void 0 ? _ownerState_color9 : 'default'].contrastText,
            background: theme.palette[(_ownerState_color10 = ownerState.color) !== null && _ownerState_color10 !== void 0 ? _ownerState_color10 : 'default'].main
        }, _define_property(_obj3, "& .".concat(_material.chipClasses.deleteIcon), {
            color: theme.palette[(_ownerState_color11 = ownerState.color) !== null && _ownerState_color11 !== void 0 ? _ownerState_color11 : 'default'].contrastText,
            fontSize: '2.2rem'
        }), _define_property(_obj3, "& .".concat(_material.chipClasses.deleteIcon, ":hover"), {
            color: theme.palette[(_ownerState_color12 = ownerState.color) !== null && _ownerState_color12 !== void 0 ? _ownerState_color12 : 'default'].light
        }), _define_property(_obj3, "&.".concat(_material.chipClasses.deletable), {
            paddingRight: 0
        }), _obj3), ownerState.color === 'default' && (_obj4 = {
            color: _constants.colors.lightItem.default.textTag,
            background: _constants.colors.lightItem.default.background
        }, _define_property(_obj4, "&.".concat(_material.chipClasses.clickable, ":hover,&.").concat(_material.chipClasses.clickable, ":focus"), {
            background: (0, _system.alpha)(theme.palette[(_ownerState_color13 = ownerState.color) !== null && _ownerState_color13 !== void 0 ? _ownerState_color13 : 'default'].dark, 0.2)
        }), _define_property(_obj4, "& .".concat(_material.chipClasses.deleteIcon), {
            color: _constants.colors.lightItem.default.textTag
        }), _obj4)));
    },
    sizeMedium: {
        fontSize: '1.4rem',
        height: 31
    },
    label: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: 10,
        paddingRight: 10
    },
    labelSmall: {
        height: 18
    },
    labelMedium: {
        height: 21
    },
    outlined: {
        borderColor: 'currentColor',
        borderWidth: 1,
        backgroundColor: 'unset'
    }
};
var defaultProps = {
    size: 'small',
    deleteIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.Clear, {
        fontSize: "inherit"
    })
};
var _default = exports.default = {
    styleOverrides: styleOverrides,
    defaultProps: defaultProps
}; //# sourceMappingURL=MuiChip.js.map
